<div class="phx-inputnumber-container w-full min-w-0 flex items-center gap-1">
    <div class="p-inputgroup w-full min-w-0 flex-1">
        <!--
            ngModel + standalone: inner p-inputNumber is not part of the host FormControl/CVA form group.
            Without standalone, Angular registers a nested control and fights the NG_VALUE_ACCESSOR on this component.
            Explicit [ngModel]/ngModelChange (not [(ngModel)]) matches phx-input-number and works when parent
            reassigns model to an external signal (e.g. widget-add-edit-line-item-list selectedQuantitySig).

        minValue must always receive a number when set: binding undefined makes PrimeNG treat min as 0 and blocks negatives.
        effectiveMin() returns -Infinity when minimumNumber is unset; step-aligned value when it is set.

        disabledSig: PrimeNG 20 disabled is a read-only input signal; setDisabledState cannot assign .disabled on the child ref.

        decimalPlaces / minFractionDigits / maxFractionDigits are set together by the parent list — no ?? fallbacks here
        so programmatic updates are not overridden.
    -->
        <app-phx-input-number
            class="w-full"
            [statusBorderColor]="statusBorderColorSig()"
            [ngModel]="model()"
            (ngModelChange)="model.set($event)"
            [ngModelOptions]="{ standalone: true }"
            [minValue]="effectiveMin()"
            [maxValue]="maximumNumber()"
            [step]="effectiveQuantityStep()"
            [minFractionDigits]="minFractionDigits()"
            [maxFractionDigits]="maxFractionDigits()"
            [upDownButtons]="upDownButtons()"
            [disabled]="disabledSig() || formControl()?.disabled"
            (focusLost)="onBlurEvent()"
            (focus)="onFocusEvent()"
        />
    </div>
</div>
